import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CalendarOutlineIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M13.3334 1.99999h-.6667V.666656h-1.3333V1.99999H4.66671V.666656H3.33337V1.99999h-.66666c-.73334 0-1.33334.6-1.33334 1.33333V14c0 .7333.6 1.3333 1.33334 1.3333H13.3334c.7333 0 1.3333-.6 1.3333-1.3333V3.33332c0-.73333-.6-1.33333-1.3333-1.33333Zm0 12.00001H2.66671V6.66666H13.3334V14Zm0-8.66668H2.66671v-2H13.3334v2Z" />
  </Icon>
);

export default memo(CalendarOutlineIcon);
